var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path3, _g, _path4, _rect7, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6640_16244)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 21.584C2 10.5383 10.9543 1.58398 22 1.58398C33.0457 1.58398 42 10.5383 42 21.584C42 32.6297 33.0457 41.584 22 41.584C10.9543 41.584 2 32.6297 2 21.584Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 21.584C2.5 10.8144 11.2304 2.08398 22 2.08398C32.7696 2.08398 41.5 10.8144 41.5 21.584C41.5 32.3535 32.7696 41.084 22 41.084C11.2304 41.084 2.5 32.3535 2.5 21.584Z",
    stroke: "#D0D5DD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.25,
    y: 12.834,
    width: 12.5,
    height: 17.5,
    rx: 2,
    fill: "#1066B5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.25,
    y: 12.834,
    width: 12.5,
    height: 17.5,
    rx: 2,
    fill: "url(#paint0_linear_6640_16244)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.25,
    y: 14.709,
    width: 6.25,
    height: 6.25,
    fill: "#32A9E7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.25,
    y: 20.959,
    width: 6.25,
    height: 6.25,
    fill: "#167EB4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 20.959,
    width: 6.25,
    height: 6.25,
    fill: "#32A9E7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 14.709,
    width: 6.25,
    height: 6.25,
    fill: "#58D9FD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6640_16244",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 20,
    width: 15,
    height: 11
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 20.334H30C31.1046 20.334 32 21.2294 32 22.334V28.334C32 29.4386 31.1046 30.334 30 30.334H19C17.8954 30.334 17 29.4386 17 28.334V20.334Z",
    fill: "url(#paint1_linear_6640_16244)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6640_16244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 20.334V22.834H30.75V20.334H32Z",
    fill: "#135298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 30.334V21.584L16.375 30.334H32Z",
    fill: "url(#paint2_linear_6640_16244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 30.334V21.584L32.625 30.334H17Z",
    fill: "url(#paint3_linear_6640_16244)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 20.209C17 18.5521 18.3431 17.209 20 17.209H21.5C23.1569 17.209 24.5 18.5521 24.5 20.209V25.459C24.5 27.1158 23.1569 28.459 21.5 28.459H17V20.209Z",
    fill: "black",
    fillOpacity: 0.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 15.959,
    width: 11.25,
    height: 11.25,
    rx: 2,
    fill: "url(#paint4_linear_6640_16244)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 21.6273V21.5234C20.75 19.7228 19.4545 18.459 17.6349 18.459C15.8054 18.459 14.5 19.7315 14.5 21.5407V21.6446C14.5 23.4451 15.7955 24.709 17.625 24.709C19.4446 24.709 20.75 23.4365 20.75 21.6273ZM19.2765 21.6446C19.2765 22.8392 18.604 23.5577 17.6349 23.5577C16.6657 23.5577 15.9834 22.8219 15.9834 21.6273V21.5234C15.9834 20.3288 16.6559 19.6103 17.625 19.6103C18.5843 19.6103 19.2765 20.3461 19.2765 21.5407V21.6446Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6640_16244",
    x: 0,
    y: 0.583984,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6640_16244"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6640_16244",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6640_16244",
    x1: 18.25,
    y1: 21.584,
    x2: 30.75,
    y2: 21.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#064484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F65B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6640_16244",
    x1: 17,
    y1: 28.3148,
    x2: 32,
    y2: 28.3148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B366F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2657B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6640_16244",
    x1: 32,
    y1: 25.959,
    x2: 17,
    y2: 25.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44DCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#259ED0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6640_16244",
    x1: 17,
    y1: 25.959,
    x2: 32,
    y2: 25.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#259ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44DCFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6640_16244",
    x1: 12,
    y1: 21.584,
    x2: 23.25,
    y2: 21.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#064484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F65B5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlook);
export default __webpack_public_path__ + "static/media/outlook.e8df0cfe3fff821c54a0b30f7959f5d4.svg";
export { ForwardRef as ReactComponent };